import WORKOUTS_PATH from '../../constants/path'
import { getCurrentIdReduxSelector } from '../../../../redux/selectors/get-current-id'

const getCurrentIdWorkoutSelect = getCurrentIdReduxSelector(
  WORKOUTS_PATH.DATA,
  WORKOUTS_PATH.CURRENT
)

export default getCurrentIdWorkoutSelect
